// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import React, { cloneElement, ReactNode, useState } from 'react';
import { Button, Paragraph, Popover, PopoverProps, useTranslate } from '@plesk/ui-library';

type PopoverConfirmProps = {
    children?: ReactNode;
    target?: PopoverProps['target'] | React.ReactNode;
};

const PopoverConfirm = ({ target, children }: PopoverConfirmProps) => {
    const translate = useTranslate('components.copilot');

    const [isVisible, setVisible] = useState(false);
    const onClick = React.isValidElement(target) ? target.props.onClick : (() => {});
    return (
        <Popover
            target={cloneElement(target as React.ReactElement, {
                onClick: () => setVisible(true),
            })}
            placement="top"
            visible={isVisible}
            onClose={() => setVisible(false)}
        >
            <Paragraph>{children}</Paragraph>
            <Button onClick={onClick} intent="danger">
                {translate('popover-confirm-btn')}
            </Button>
            {' '}
            <Button onClick={() => setVisible(false)}>{translate('popover-confirm-cancel')}</Button>
        </Popover>
    );
};

export default PopoverConfirm;
